'use client';

import { useEffect, useState } from 'react';
import LaunchScreen from '@/components/common/LaunchScreen';

export default function LaunchGate({
  children,
}: {
  children: React.ReactNode;
}) {
  const [showSite, setShowSite] = useState(false);

  useEffect(() => {
    const launchTime = new Date('2026-01-08T17:05:00+05:30').getTime();
    const now = Date.now();

    if (now >= launchTime) {
      setShowSite(true);
    }

    const timer = setInterval(() => {
      if (Date.now() >= launchTime) {
        setShowSite(true);
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  if (!showSite) {
    return <LaunchScreen data-component-id="src/components/common/LaunchGate.tsx:32:11" data-component-path="src/components/common/LaunchGate.tsx" data-component-line="32" data-component-end-line="32" data-component-file="LaunchGate.tsx" data-component-name="LaunchScreen" data-component-content="%7B%22elementName%22%3A%22LaunchScreen%22%7D" onLaunch={() => setShowSite(true)} />;
  }

  return <>{children}</>;
}



